import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DailyImporterV21Page } from './pages/daily-importer-v2.1/daily-importer.page';
import { DailyImporterPage } from './pages/daily-importer-v2/daily-importer-old.page';
import { DailyImporterV3Page } from './pages/daily-importer-v3/daily-importer-v3.page';
import { ManagerUploaderPage } from './pages/manager-uploader/manager-uploader.page';

const routes: Routes = [
  {
    path: 'daily-importer-osp',
    component: DailyImporterPage
  },
  {
    path: 'daily-importer-cp-osp/:guid',
    component: DailyImporterV21Page
  },
  {
    path: 'daily-importer-cp/:guid',
    component: DailyImporterV3Page
  },
  {
    path: 'manager-uploader/:guid',
    component: ManagerUploaderPage
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
